import { useDataChange, useDataValue } from 'Simple/Data.js'
import debounce from 'lodash/debounce.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'global',
    viewPath: props.viewPath,
  })
  let { id: tab_id } = data

  let is_new_calendar_default_enabled = useDataValue({
    context: 'global',
    viewPath: props.viewPath,
    path: 'feature_flags.is_new_calendar_default_enabled',
  })

  return debounce(async function onChange(next, ...args) {
    if (!next || is_new_calendar_default_enabled) return

    change(inext => {
      if (tab_id !== inext.tab_id) return

      inext.tabs = inext.tabs.map(item => (item.id === tab_id ? next : item))
    })
  }, 250)
}
